import { render, staticRenderFns } from "./CsServicioForm.vue?vue&type=template&id=1c6b752b"
import script from "./CsServicioForm.vue?vue&type=script&lang=js"
export * from "./CsServicioForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports